import { Link, Metadata } from "@readium/shared";
import {
  ReadingSession,
  ReadingSessionAuth,
  ReadingSessionContent,
} from "./session";

export function serializeSession(session: ReadingSession): unknown {
  if (!session) {
    return null;
  }

  return {
    ...session,
    auth: session.auth ? serializeAuth(session.auth) : null,
    content: session.content ? serializeContent(session.content) : null,
  };
}

export function deserializeSession(data: unknown): ReadingSession | null {
  if (!data) {
    return null;
  }

  return {
    ...(data as ReadingSession),
    auth: deserializeAuth((data as object)["auth"]),
    content: deserializeContent((data as object)["content"]),
  };
}

function serializeAuth(auth: ReadingSessionAuth): unknown {
  if (!auth) {
    return null;
  }

  return {
    ...auth,
    links: auth.links?.map((link) => link.serialize()),
  };
}

function deserializeAuth(auth: unknown): ReadingSessionAuth | null {
  if (!auth) {
    return null;
  }

  return {
    ...(auth as ReadingSessionAuth),
    links: deserializeLinks((auth as object)["links"]),
  };
}

function serializeContent(content: ReadingSessionContent): unknown {
  if (!content) {
    return null;
  }

  return {
    ...content,
    metadata: content.metadata?.serialize(),
    resources: content.resources?.map((link) => link.serialize()),
    links: content.links?.map((link) => link.serialize()),
  };
}

function deserializeContent(content: unknown): ReadingSessionContent | null {
  if (!content) {
    return null;
  }

  const metadata = (content as object)["metadata"];
  return {
    ...(content as ReadingSessionContent),
    metadata: metadata && Metadata.deserialize(metadata),
    resources: deserializeLinks((content as object)["resources"]),
    links: deserializeLinks((content as object)["links"]),
  };
}

const identity = <T>(x: T): T => x;

function deserializeLinks(links: unknown): Link[] | null {
  if (!links || !Array.isArray(links)) {
    return null;
  }

  return links.map((link) => Link.deserialize(link)).filter(identity);
}
